import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { DeployCostQuote } from './DeployCostQuote';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MainnetConfirmDialog = ({ open, contractType, network, confirmText, deployer, token, onCancel, onConfirm }) => {
  const netId = network?.id || 'mainnet';
  const netLabel = network?.label || 'Ethereum';
  const [value, setValue] = useState('');
  const [quote, setQuote] = useState(null);
  const [quoteError, setQuoteError] = useState('');
  useEffect(() => {
    if (!open) return;
    setValue(''); setQuote(null); setQuoteError('');
    axios.get(`${API}/pas-admin/contracts/deploy-quote`, {
      params: { contract_type: contractType, network: netId }, headers: { Authorization: `Bearer ${token}` },
    }).then(r => setQuote(r.data)).catch(e => setQuoteError(e.response?.data?.detail || 'Could not estimate deployment cost'));
  }, [open, contractType, token, netId]);
  const matches = value.trim() === confirmText && quote?.sufficient;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="bg-slate-900 border-amber-500/40 text-white" data-testid="mainnet-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-300">
            <AlertTriangle className="w-5 h-5" /> {netLabel} deployment
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Deploying <span className="text-white font-medium">{contractType}</span> spends real ETH from
            <code className="text-purple-300 mx-1 break-all">{deployer}</code> and is permanent.
          </DialogDescription>
        </DialogHeader>
        <DeployCostQuote quote={quote} loading={!quote && !quoteError} error={quoteError} networkLabel={netLabel} />
        <label className="text-sm text-slate-300">
          Type <code className="text-amber-300 font-semibold">{confirmText}</code> to continue
        </label>
        <input
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          data-testid="mainnet-confirm-input"
          className="w-full bg-slate-800 border border-slate-600 rounded-md px-3 py-2 text-white font-mono focus:outline-none focus:border-amber-400"
        />
        <DialogFooter>
          <button onClick={onCancel} data-testid="mainnet-confirm-cancel-btn" className="px-4 py-2 text-sm text-slate-300 hover:text-white">Cancel</button>
          <button
            disabled={!matches}
            onClick={() => onConfirm(value.trim())}
            data-testid="mainnet-confirm-submit-btn"
            className="px-4 py-2 text-sm rounded-md bg-amber-500 hover:bg-amber-600 disabled:opacity-40 disabled:cursor-not-allowed text-white font-medium"
          >
            Deploy to {netLabel}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MainnetConfirmDialog;
